import { formatNumberToCurrencyString, formatNumberToFixed3Decimals } from 'utils/number';

import { CellId } from './AmortizationScheduleTable.constants';

export const getTableConfig = ({ isBuyDown }) => ({
  [CellId.PAYMENT_NUMBER]: {
    label: 'Payment Number',
  },
  [CellId.MONTHLY_PAYMENT]: {
    label: 'Monthly Payment',
    content: ({ monthlyPayment }) => formatNumberToCurrencyString(monthlyPayment),
  },
  [CellId.INTEREST]: {
    label: 'Interest',
    content: ({ interest }) => formatNumberToCurrencyString(interest),
  },
  [CellId.PRINCIPAL]: {
    label: 'Principal',
    content: ({ principal }) => formatNumberToCurrencyString(principal),
  },
  [CellId.MI]: {
    label: 'MI (Mortgage Insurance)',
    content: ({ mi }) => formatNumberToCurrencyString(mi),
  },
  [CellId.MONTHLY_SUBSIDIZED_AMOUNT]: {
    label: 'Monthly Subsidized Amount',
    content: ({ monthlySubsidizedAmount }) => formatNumberToCurrencyString(monthlySubsidizedAmount),
    isHidden: !isBuyDown,
  },
  [CellId.BALANCE]: {
    label: 'Remaining Balance',
    content: ({ remainingBalance }) => formatNumberToCurrencyString(remainingBalance),
  },
  [CellId.TOTAL_MONTHLY_PAYMENT]: {
    label: 'Total Monthly Payment',
    content: ({ totalMonthlyPayment }) => formatNumberToCurrencyString(totalMonthlyPayment),
  },
  [CellId.TOTAL_INTEREST]: {
    label: 'Total Interest',
    content: ({ totalInterest }) => formatNumberToCurrencyString(totalInterest),
  },
  [CellId.RATE]: {
    label: 'Rate',
    content: ({ interestRate }) => formatNumberToFixed3Decimals(interestRate),
  },
});
